// tslint:disable-next-line:no-any
export const roundValue = (value: any, precision?: number): any => {
  const coercedValue = +value;
  if (!isNaN(coercedValue)) {
    return +coercedValue.toFixed(precision);
  } else {
    try {
      return value.toFixed(precision);
    } catch {
      return value;
    }
  }
};

// tslint:disable-next-line:no-any
export const roundValueCurryable = (precision: number, value: any): any => {
  const coercedValue = +value;
  if (!isNaN(coercedValue)) {
    return +coercedValue.toFixed(precision);
  } else {
    return value;
  }
};
